
import PropertyFilters from '@/components/PropertyFilters';
import { useSearch } from '@/context/SearchContext';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

const SearchFilters = () => {
  const [searchParams] = useSearchParams();
  const { handleFilterChange, isFiltersVisible, activeFilters } = useSearch();
  const [initialFilters, setInitialFilters] = useState({
    categories: [] as string[],
    types: [] as string[],
    locations: [] as string[],
    priceRange: [0, 50000000] as [number, number],
  });

  // Extract initial filter values from URL params on component mount
  useEffect(() => {
    const categories: string[] = [];
    const listingType = searchParams.get('listing_type');
    if (listingType) {
      categories.push(listingType);
    }

    const types = searchParams.getAll('propertyType');
    const locations = searchParams.getAll('location');

    // Parse price range
    const minPrice = searchParams.get('minPrice');
    const maxPrice = searchParams.get('maxPrice');
    const priceRange: [number, number] = [
      minPrice ? parseInt(minPrice) : 0,
      maxPrice ? parseInt(maxPrice) : 50000000
    ];

    setInitialFilters({
      categories,
      types,
      locations,
      priceRange,
    });
  }, [searchParams]);

  return (
    <div className={`w-full md:w-64 flex-shrink-0 ${isFiltersVisible ? 'block' : 'hidden md:block'}`}>
      <PropertyFilters 
        onFilterChange={handleFilterChange} 
        initialFilters={initialFilters}
      />
    </div>
  );
};

export default SearchFilters;
